export default {"src":"/_next/static/media/google-icon.acc6e741.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};